import { Injectable }    from '@angular/core';
import * as JSBase64 from 'js-base64';
import * as jsSHA from 'jssha';
import { User } from '../entity/user';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class WsseService {

  constructor(private authenticationService: AuthenticationService) { }

  getHeader(): string {
    if (this.authenticationService.isAuthenticated()) {
      let user: User = this.authenticationService.getCurrentUser();
      return this.generateWsse(user.mail, user.password, user.thirdParty.id);
    } else {
      return "";
    }
  }

  /**
   * Generate X-WSSE token
   * @param  {string} username
   * @param  {string} password
   * @return {string}
   */
  generateWsse(username, password, thirdPartyId): string {
    let nonce = this.generateNonce(16);
    let nonce64 = JSBase64.Base64.encode(nonce);
    let now = new Date();
    let created = now.toISOString();

    // Compute password digest
    let shaObj = new jsSHA('SHA-1', 'TEXT'); // eslint-disable-line
    shaObj.update(nonce + created + password);
    let passwordDigest = shaObj.getHash('B64');

    return 'UsernameToken Username="' + username + '", PasswordDigest="' + passwordDigest + '", Nonce="' + nonce64 + '", Created="' + created + '", ThirdPartyId="' + thirdPartyId + '"';
  }

  /**
   * Generate nonce
   * @param  {int} length
   * @return {string}
   */
  generateNonce(length): string {
    var nonceChars = '0123456789abcdef';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += nonceChars.charAt(Math.floor(Math.random() * nonceChars.length));
    }
    return result;
  }

}


// WEBPACK FOOTER //
// ./src/app/security/wsse.service.ts